
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getUpdateLeadcategoryDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
})
;
}
      